import { helper } from '@ember/component/helper';
import { statusBgColors, statusTextColors } from 'scaleflow/utils/colorClasses';

export default helper(function statusColorClass([status] /*, named*/) {
  const bgColor = statusBgColors[status?.toUpperCase()] ?? 'bg-gray-100';
  const textColor = statusTextColors[status?.toUpperCase()] ?? 'text-gray-700';
  return `${bgColor} ${textColor}`;
});
